import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  UPDATE_AUTH_USER
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("user"));
const tokenExpiresAt = localStorage.getItem("tokenExpiresAt");
const refreshTokenExpiresAt = localStorage.getItem("refreshTokenExpiresAt");

// Verificar si el refresh token ha expirado
const isRefreshTokenExpired = () => {
  if (!refreshTokenExpiresAt) return false; // Si no hay fecha, asumir válido
  const expirationDate = new Date(refreshTokenExpiresAt);
  const now = new Date();
  return expirationDate <= now;
};

// Si hay usuario pero el refresh token expiró, limpiar localStorage
if (user && isRefreshTokenExpired()) {
  localStorage.removeItem("user");
  localStorage.removeItem("tokenExpiresAt");
  localStorage.removeItem("refreshTokenExpiresAt");
}

const initialState = user && !isRefreshTokenExpired()
  ? { 
      isLoggedIn: true, 
      user,
      tokenExpiresAt,
      refreshTokenExpiresAt
    }
  : { 
      isLoggedIn: false, 
      user: null,
      tokenExpiresAt: null,
      refreshTokenExpiresAt: null
    };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
        tokenExpiresAt: payload.tokenExpiresAt,
        refreshTokenExpiresAt: payload.refreshTokenExpiresAt,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        tokenExpiresAt: null,
        refreshTokenExpiresAt: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        tokenExpiresAt: null,
        refreshTokenExpiresAt: null,
      };
    case UPDATE_AUTH_USER: {
      if (!state.user) return state;
      const patch = action.payload || {};
      return {
        ...state,
        user: {
          ...state.user,
          ...patch,
          token: patch.token ?? state.user.token,
          refreshToken: patch.refreshToken ?? state.user.refreshToken
        },
        tokenExpiresAt: patch.tokenExpiresAt ?? state.tokenExpiresAt,
        refreshTokenExpiresAt: patch.refreshTokenExpiresAt ?? state.refreshTokenExpiresAt
      };
    }
    default:
      return state;
  }
}
